// Shared layout primitives used across multiple Analytics components.
// Extracted only when they appear in 3+ files (KISS/DRY rule of three).
import styled from '@emotion/styled';

export const Section = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
});

export const SectionLabel = styled.div(({ theme }) => ({
  fontSize: '0.78rem',
  fontWeight: 600,
  color: theme.palette.text.secondary,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
}));

export const Pill = styled.button<{ selected?: boolean }>(({ theme, selected }) => ({
  appearance: 'none',
  border: `1px solid ${selected ? theme.palette.primary.main : 'rgba(15, 23, 42, 0.12)'}`,
  background: selected ? theme.palette.primary.main : '#fff',
  color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
  borderRadius: '999px',
  padding: '0.3rem 0.7rem',
  fontSize: '0.78rem',
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'all 140ms ease',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.35rem',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '&:focus-visible': {
    outline: 'none',
    boxShadow: `0 0 0 3px ${theme.palette.primary.main}33`,
  },
}));

export const EmptyState = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.75rem',
  color: theme.palette.text.secondary,
}));
